import React, { FC } from 'react';
import { graphql } from 'gatsby';

import Header from 'src/components/Header';
import Layout from 'src/components/Layout';
import ContactsBlock from 'src/components/ContactsBlock';
import Footer from 'src/components/Footer';

interface ContactsProps {
  data: any;
}

const Contacts: FC<ContactsProps> = ({ data }) => {
  const {
    frontmatter: { title, phone, email, address },
  } = data.content;

  return (
    <>
      <Header isWhite />
      <Layout>
        <ContactsBlock
          title={title}
          contacts={{
            phone: `${phone}`,
            email: `${email}`,
            address: `${address}`,
          }}
          isContactsPage
        />
      </Layout>
      <Footer />
    </>
  );
};

export default Contacts;

export const query = graphql`
  query Contacts {
    content: mdx(slug: { eq: "contacts/" }) {
      frontmatter {
        title
        phone
        email
        address
      }
    }
  }
`;
